<script>
import RubricItem from '@/components/RubricItem'
import CombinedRubricItem from '@/components/CombinedRubricItem'

export default {
  name: 'ReviewSections',
  components: {
    RubricItem,
    CombinedRubricItem
  },
  props: {
    categoryObject: Object
  },
  data() {
    return {
      standards: this.categoryObject.standards,
      categoryIdentifier: `Category ${this.categoryObject.id}: ${this.categoryObject.text}`
    }
  },
  computed: {
    reviewInfo() {
      return this.$store.getters.reviewInfo
    },
    dashboard() {
      if (
        this.reviewInfo.reviewer_role === 'OFDIT reviewer' ||
        this.reviewInfo.reviewer_role === 'Peer reviewer'
      ) {
        return false
      } return true
    }
  }
}
</script>

<template>
  <div>
    <h4>{{ categoryIdentifier }}</h4>
    <div v-for="standard in standards" :key="standard.id">
      <h5 class="text-muted">
        {{ standard.text }}
      </h5>
      <div v-if="!dashboard">
        <RubricItem v-for="item in standard.items" :key="item" :rubricId="item" />
      </div>
      <div v-else>
        <CombinedRubricItem v-for="item in standard.items" :key="item" :rubricId="item" />
      </div>
    </div>
  </div>
</template>

<style></style>
